import React, { useRef } from "react";
import { Helmet } from "react-helmet";

import Config from "../Config.json";
import { Link, useNavigate } from "react-router-dom";

const TITLE = "DBC | " + Config.SITE_TITLE;
const DESC = "Create a React App from an HTML Website.";
const CANONICAL = Config.SITE_DOMAIN + "/";

const Imprint = () => {
  return (
    <main className="contact-main-content">
      <Helmet>
        <title>{TITLE}</title>
        <Link rel="canonical" href={CANONICAL}></Link>
        <meta name="description" content={DESC} />
        <meta name="theme-color" content={Config.THEME_COLOR} />
      </Helmet>
      <div className="w-100">
        <div className="contact-container">
          <h1 className="contact py-3 ps-3">Imprint / Legal Disclosure</h1>
        </div>
        <div className="contact-content-container w-75">
          <h2 className="contact-color contact-margin-y">
            Imprint / Legal Disclosure
          </h2>
          <p>
            <strong>Website Owner:</strong>
            <br />
            Zsolt Fenyő
            <br />
            PowerCode Web Solutions
            <br />
            Arpad Street 9
            <br />
            3109 Salgótarján, Nógrád
          </p>

          <p>
            <strong>Contact Information:</strong>
            <br />
            Email: <a href="mailto:info@powercode.hu">info@PowerCode.hu</a>
            <br />
            Phone: +36 30 483 0461
          </p>

          {/*<p>
            <strong>VAT ID (if applicable):</strong>
            <br />
            EU VAT No: DE123456789
          </p>*/}

          <p>
            <strong>
              Responsible for content according to § 55 Abs. 2 RStV:
            </strong>
            <br />
            PowerCode Web Solutions
          </p>

          <p>
            <strong>Disclaimer:</strong>
            <br />
            Despite careful content control, we assume no liability for the
            content of external links. The content of linked pages is the sole
            responsibility of their operators.
          </p>
        </div>
      </div>
    </main>
  );
};

export default Imprint;
